 <template>
  <div>
    <nav-bar></nav-bar>
    <section class="section">
      <form id="buyItems" @submit.prevent="next" ref="form"></form>
      <div class="field is-grouped">
      <div class="control">
        <label class="label">Category</label>
        <div class="select">
          <select v-model="category">
            <option value="shades" selected>Manual Shades</option>
            <option value="motorized">Motorized Shades</option>
          </select>
        </div>
      </div>
      <div class="control">
        <label class="label">Operation System</label>
          <div class="select">
            <select v-model="operationSystem">
              <option value="">Skyline</option>
              <option value="">R-Series</option>
            </select>
          </div>
      </div>
      </div>
      </section>
      <section>
      <div class="section sticky">
        <buy-cell :values="{}" :is-first="true" :total-qty="totalQty"></buy-cell>
      </div>
      <div v-if="this.buyCells.length === 0" class="section">
        <button type="button" @click="addEmpty(-1)" class="button is-info is-small">open blank line</button>
      </div>
      <div v-for="(cell, idx) in buyCells" :key="cell.id">

        <div class="section">
          <p class="is-size-7">
        {{idx+1}}. <a @click="remove(idx)">(remove)</a>
        </p>
          <buy-cell
            @cell-changed="cellChanged(idx, $event)"
            :values="cell"
            :category="category"
            :orderOptions="orderOptions"
            :required="!isEmpty(cell)"
          >
          </buy-cell>
          <div class="buttons" >
            <button type="button" @click="copyThis(idx)" class="button is-primary is-small">copy this line</button>
            <button type="button" @click="addEmpty(idx)" class="button is-info is-small">open blank line</button>
            <button type="button" @click="copyThisWithoutSizes(idx)" class="button is-info is-small">copy last no sizes</button>
          </div>
        </div>
      </div>
      <section class="section">
      <div class="field">
      <div class="control">
        <label for="" class="label">Notes</label>
        <textarea class="textarea is-fullwidth" v-model="notes" placeholder="Enter your notes here"></textarea>
      </div>
    </div>
    </section>
    </section>
    <section class="section container has-text-centered">
      <button type="submit" form="buyItems" class="button is-primary">Next</button>
    </section>
  </div>
</template>

<script>
import BuyCell from '@/components/BuyCell.vue';
import { getOrderOptions } from '@/utils/api';

export default {
  components: {
    'buy-cell': BuyCell,
  },
  async created() {
    try {
      const { data } = await getOrderOptions();
      this.orderOptions = data;
    } catch (err) {
      console.error(err);
    }
  },
  mounted() {
    window.addEventListener('unload', this.leaving);
  },
  data() {
    return {
      orderOptions: {},
      operationSystem: JSON.parse(window.localStorage.getItem('ed-cart-operation-system')),
      category: JSON.parse(window.localStorage.getItem('ed-cart-category')) || 'shades',
      buyCells: JSON.parse(window.localStorage.getItem('ed-cart-items')) || [{ id: 0 }],
      lastId: JSON.parse(window.localStorage.getItem('ed-cart-last-id')) || 0,
      notes: JSON.parse(window.localStorage.getItem('ed-cart-notes')),
    };
  },
  methods: {
    cellChanged(idx, payload) {
      this.buyCells.splice(idx, 1, payload);
    },
    copyThis(idx) {
      this.lastId += 1;
      this.buyCells.splice(idx + 1, 0, { ...this.buyCells[idx], id: this.lastId });
      // this.buyCells.push({ ...this.buyCells[idx], id: this.lastId });
    },
    copyThisWithoutSizes(idx) {
      this.lastId += 1;
      const newRow = {
        ...this.buyCells[idx],
        id: this.lastId,
        size: {},
      };
      this.buyCells.splice(idx + 1, 0, newRow);
      // this.buyCells.push(newRow);
    },
    copyLast() {
      this.lastId += 1;
      this.buyCells.push({ ...this.buyCells[this.buyCells.length - 1], id: this.lastId });
    },
    copyLastWithoutSizes() {
      this.lastId += 1;
      const newRow = {
        ...this.buyCells[this.buyCells.length - 1],
        id: this.lastId,
        size: {},
      };
      this.buyCells.push(newRow);
    },
    addEmpty(idx) {
      this.lastId += 1;
      this.buyCells.splice(idx + 1, 0, { id: this.lastId });
      // this.buyCells.push({ id: this.lastId });
    },
    remove(idx) {
      this.buyCells.splice(idx, 1);
    },
    leaving() {
      // if (this.lastOfBuyCellsIsEmpty) {
      //   // TODO: replace with generic empty cell remover
      //   this.remove(this.buyCells.length - 1);
      // }
      window.localStorage.setItem('ed-cart-operation-system', JSON.stringify(this.operationSystem));
      window.localStorage.setItem('ed-cart-category', JSON.stringify(this.category));
      window.localStorage.setItem('ed-cart-items', JSON.stringify(this.buyCells));
      window.localStorage.setItem('ed-cart-last-id', JSON.stringify(this.lastId));
      window.localStorage.setItem('ed-cart-notes', JSON.stringify(this.notes));
    },
    next() {
      this.leaving();
      this.$router.push({ name: 'buySubmit' });
    },
    isEmpty(cell) {
      return Object.keys(cell).length <= 1;
    },
  },
  computed: {
    lastOfBuyCellsIsEmpty() {
      return this.buyCells.length > 0 && this.isEmpty(this.buyCells[this.buyCells.length - 1]);
    },
    totalQty() {
      const total = this.buyCells.reduce((accumulator, cur) => accumulator + (cur.qty || 0), 0);
      console.log('recalculating total qty', total)
      console.table(this.buyCells)
      return total;
    },
  },
};
</script>

<style scoped>
.section {
  padding: .5rem 1.5rem;
}
.sticky {
  background-color: white;
  z-index: 100;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding-bottom: 0;
}
 </style>
